import { Component } from 'react'
import { Input } from '../../../../../components/input'
import { SubmitBtn } from '../../../../../components/submit'
import { emptyField, ErrorMessage, errorsLength, formatErrors, validateCEP } from '../../../../../../insfrastructure/utils/form-validators'
import { Select } from '../../../../../components/select'
import { retrieveCandidate, updateCandidate } from '../../../../../../insfrastructure/services/candidates'
import { listCities } from '../../../../../../insfrastructure/services/cities'
import { StaticValues } from '../../../../../../insfrastructure/services/static_values'
import ResponseModal from '../../../../../components/response-modal'
import { retrievePostcodeInfo } from '../../../../../../insfrastructure/services/cep'
import moment from 'moment'
import './styles.sass'

export default class PersonalForm extends Component {

  state: any = {
    form: {
      email: '',
      password:  ''
    },
    cnh_categories: [],
    formErrors: {},
    loading: false,
    cityOptions: []
  }
  timeout: any = null

  async componentDidMount() {
    try {            
      let candidate = await retrieveCandidate();

      if (candidate.date_of_birth) {
        // let date_parts = candidate.date_of_birth.split('-');
        // date_parts.reverse();
        // let date = date_parts.join('/');
        // // let year = date_parts.shift();
        
        // // let date = date_parts.join('-') + '-' + year;
        // console.log(date);

        // candidate.date_of_birth =  moment(date).toDate() as any;
        // console.log(candidate.date_of_birth);
        
        candidate.date_of_birth = moment(candidate.date_of_birth).toDate() as any;
      };

      this.setState({ form: candidate }, () => {
        this.onCEPChange(this.state.form.postcode);
      });
    } catch (error) {}

    this.getStaticValues();
  }

  getStaticValues = async () => {
    try {  
      setTimeout(() => {
        const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
        const cnh_categories = Object.keys(staticValues.cnh_category).map((key: any) => ({ value: key, label: staticValues.cnh_category[key] }));
        const marital_status = Object.keys(staticValues.marital_status).map((key: any) => ({ value: key, label: staticValues.marital_status[key] }));
        const gender = Object.keys(staticValues.gender).map((key: any) => ({ value: key, label: staticValues.gender[key] }));
        const education_level = Object.keys(staticValues.education_level).map((key: any) => ({ value: key, label: staticValues.education_level[key] }));
        const disability = Object.keys(staticValues.disability).map((key: any) => ({ value: key, label: staticValues.disability[key] }));     
        
        this.setState({ cnh_categories, marital_status, gender, education_level, disability });
      }, 1000);
    } catch (error) {}
  }

  onSubmit = async () => {
    const errors = formatErrors({
      full_name: [emptyField(this.state.form.full_name, 'string')],
      postcode: [emptyField(this.state.form.postcode, 'string')],
      city_id: [emptyField(this.state.form.city_id, 'string')],
      address_number: [emptyField(this.state.form.address_number, 'string')],
      mobile: [emptyField(this.state.form.mobile, 'string')]
    });

    this.setState({ formErrors: errors });
  
    if(errorsLength(errors) > 0) return;

    try {
      this.setState({ loading: true });
  
      let data = {...this.state.form};
  
      if (data.date_of_birth) {
        if (typeof data.date_of_birth === 'object') {
          const offset = data.date_of_birth.getTimezoneOffset();
          data.date_of_birth = new Date(data.date_of_birth.getTime() - (offset*60*1000));
          data.date_of_birth = data.date_of_birth.toISOString().split('T')[0];
        } else {
          data.date_of_birth = moment(data.date_of_birth).format('YYYY-MM-DD');
        };
      };
        
      if (data.cnh_validity && typeof data.cnh_validity === 'object') {
        const offset = data.cnh_validity.getTimezoneOffset()
        data.cnh_validity = new Date(data.cnh_validity.getTime() - (offset*60*1000))
        data.cnh_validity = data.cnh_validity.toISOString().split('T')[0]
      };

      !data.escola_do_mecanico_id && delete data.escola_do_mecanico_id;
      if (!data.address_complement || (typeof data.address_complement === 'string' && data.address_complement.trim() === '')) {
        data.address_complement = null;
      };
                 
      const candidate = await updateCandidate(localStorage.getItem('candidate_id')+'', data);

      let responseData = {
        type: 'success',
        title: 'Dados atualizados com sucesso!',
        text: () => <></>
      };
        
      setTimeout(() => {
        this.setState({ loading: false, form: candidate, responseData });
      });
    } catch (error: any) {
      let errors: string[] = [];

      if (error.response.data['email']) {
        errors.push('Email já cadastrado');
      };
      
      if (error.response.data['username']) {
        errors.push('Nome de usuário já cadastrado');
      };

      let responseData = {
        type: 'error',
        title: 'Erro ao atualizar dados',
        text: () => <>
          { errors.map(error => <p>{error}</p>) }
        </>
      };

      this.setState({ loading: false, responseData });
    }
  }

  onCityNameChange = async (e: any) => {
    const cityOptions = (await listCities(e)).map(x => ({ value: x.id, label: x.displayName }));

    this.setState({ cityOptions });
  }

  onCEPChange = async (value: any) => {
    clearTimeout(this.timeout);
    
    this.timeout = setTimeout(async () => {
      let city_id = '';
      let city_uf = '';
      let address_district = '';
      let street = '';
      let result = null;

      if(validateCEP(value) === '') {
        try {
          result = await retrievePostcodeInfo(value);
        } catch (error) {
          this.setState({
            responseData: {
              type: 'error',
              title: 'CEP Inválido',
              text: ''
            }
          });

          return;
        };

        this.onCityNameChange(result?.localidade);
        city_id = result?.city_id + '';
        city_uf = result?.uf + '';
        address_district = result?.bairro + '';
        street = result?.logradouro + '';
      };
  
      this.setState({
        form: {
          ...this.state.form,
          city_id,
          city_uf,
          address_district,
          address: street
        }
      });
    }, 1000);
  }

  render() {
    return (
      <div className='personal-form'>
        <h1>Dados Pessoais</h1>
        <div className='columns'>
          <div className='column'>
            <Input
            name='full_name'
            label='Nome Completo'
            value={this.state.form['full_name']}
            onChange={e => this.setState({ form: { ...this.state.form, full_name: e } })}/>
            <ErrorMessage errors={this.state.formErrors['full_name']} />
            <Input
            name='mobile'
            label='Celular'
            mask='(99) 99999-9999'
            value={this.state.form['mobile']}
            onChange={e => this.setState({ form: { ...this.state.form, mobile: e } })}/>
            <ErrorMessage errors={this.state.formErrors['mobile']} />
            <Input
            name='date_of_birth'
            label='Data Nascimento'
            type='date'
            dateFormat='dd/MM/yyyy'
            value={this.state.form['date_of_birth']}
            onChange={e => this.setState({ form: { ...this.state.form, date_of_birth: e } })}/>
            <ErrorMessage errors={this.state.formErrors['date_of_birth']} />
            <Select
            name='gender'
            label='Gênero'
            value={this.state.form['gender']}
            options={this.state.gender}
            onChange={e => this.setState({ form: { ...this.state.form, gender: e } })}/>
            <ErrorMessage errors={this.state.formErrors['gender']} />
          </div>
          <div className='column'>
            <Input
            name='salary_expectation'
            label='Pretensão Salarial'
            value={this.state.form['salary_expectation']}
            onChange={e => this.setState({ form: { ...this.state.form, salary_expectation: e } })}/>
            <ErrorMessage errors={this.state.formErrors['salary_expectation']} />
            <Select
            name='marital_status'
            label='Estado Civil'
            value={this.state.form['marital_status']}
            options={this.state.marital_status}
            onChange={e => this.setState({ form: { ...this.state.form, marital_status: e } })}/>
            <ErrorMessage errors={this.state.formErrors['marital_status']} />
            <Select
              name='education_level'
              label='Escolaridade'
              placeholder='Escolaridade'
              value={this.state.form['education_level']}
              options={this.state.education_level}
              onChange={e => this.setState({ form: { ...this.state.form, education_level: e } })}/>
              <ErrorMessage errors={this.state.formErrors['education_level']} />
            <Select
            name='disability'
            label='Deficiência'
            value={this.state.form['disability']}
            options={this.state.disability}
            onChange={e => this.setState({ form: { ...this.state.form, disability: e } })}/>
            {this.state.form.disability === 'Outro' &&
            <>
              <Input
              name='expecific_disability'
              label='Especificar Deficiência'
              onChange={e => this.setState({ form: { ...this.state.form, expecific_disability: e } })}/>
              <ErrorMessage errors={this.state.formErrors['expecific_disability']} />
            </>}
          </div>
        </div>
        <div className='columns'>
          <div className='column'>
            <Input
            name='postcode'
            label='CEP'
            mask='99999-999'
            value={this.state.form.postcode}
            onChange={e => { this.setState({ form: { ...this.state.form, postcode: e } }); this.onCEPChange(e); }}/>
            <ErrorMessage errors={this.state.formErrors['postcode']} />
            <Input
            name='address'
            label='Endereço'
            value={this.state.form.address}
            readonly={true}
            onChange={e => this.setState({ form: { ...this.state.form, address: e } })}/>
            <ErrorMessage errors={this.state.formErrors['address']} />
            <Input
            name='address_number'
            label='Número'
            value={this.state.form.address_number}
            onChange={e => this.setState({ form: { ...this.state.form, address_number: e } })}/>
            <ErrorMessage errors={this.state.formErrors['address_number']} />
            <Input
            name='address_complement'
            label='Complemento'
            value={this.state.form.address_complement}
            onChange={e => this.setState({ form: { ...this.state.form, address_complement: e } })}/>
            <ErrorMessage errors={this.state.formErrors['address_complement']} />
          </div>
          <div className='column'>
          <Input
            name='address_district'
            label='Bairro'
            value={this.state.form.address_district}
            readonly={true}
            onChange={e => this.setState({ form: { ...this.state.form, address_district: e } })}/>
            <ErrorMessage errors={this.state.formErrors['address_district']} />
            <Select
            name='city_id'
            label='Cidade'
            options={this.state.cityOptions}
            value={this.state.form.city_id}
            readonly={true}
            onSearchChange={e => this.onCityNameChange(e)}
            onChange={e => this.setState({ form: { ...this.state.form, city_id: e } })}/>
            <ErrorMessage errors={this.state.formErrors['city_id']} />
            <Input
            name='city_uf'
            label='Estado'
            value={this.state.form.city_uf}
            readonly={true}
            onChange={e => this.setState({ form: { ...this.state.form, city_uf: e } })}/>
            <ErrorMessage errors={this.state.formErrors['city_uf']} />
          </div>
        </div>
        <div className='columns'>
          <div className='column'>
            <Input
            name='cnh_number'
            label='Número da CNH'
            value={this.state.form.cnh_number}
            onChange={e => this.setState({ form: { ...this.state.form, cnh_number: e } })}/>
            <ErrorMessage errors={this.state.formErrors['cnh_number']} />
            <Input
            name='cnh_validity'
            label='Validade da CNH'
            type='date'
            value={this.state.form.cnh_validity}
            onChange={e => this.setState({ form: { ...this.state.form, cnh_validity: e } })}/>
            <ErrorMessage errors={this.state.formErrors['cnh_validity']} />
          </div>
          <div className='column'>
            <Select
            name='cnh_category'
            label='Categoria da CNH'
            value={this.state.form.cnh_category}
            options={this.state.cnh_categories}
            onChange={e => this.setState({ form: { ...this.state.form, cnh_category: e } })}/>
            <ErrorMessage errors={this.state.formErrors['cnh_category']} />
          </div>
        </div>
        <SubmitBtn className='secondary' text='Salvar Alterações' loadingText='Salvando...' loading={this.state.loading} onSubmit={this.onSubmit} />
        <ResponseModal
        render={this.state.responseData}
        type={this.state.responseData?.type}
        title={this.state.responseData?.title}
        text={this.state.responseData?.text}
        onClose={() => this.setState({ responseData: null })} />
      </div>
    )
  }
}
